import BreadCrumb from './BreadCrumb.vue'
// 这里是重点
const Bread = {
  install: function(Vue) {
    Vue.component('Bread', BreadCrumb)
  }
}

// 导出组件
export default Bread
